import { createSelector } from 'reselect';
import { OccupantContact } from '@centecomm/portal-service';

import { LoadStatus, State } from '../../Types';

const contactsState = ({ contacts }: State) => contacts;

// Occupant Contacts
const occupantsSlice = createSelector(contactsState, ({ occupants }) => occupants);

export const contactsAreLoadedForOccupant = (occupantId: number | string) =>
    createSelector(occupantsSlice, (contacts) => contacts.hasOwnProperty(occupantId));

export const occupantContacts = (occupantId: number | string) =>
    createSelector(occupantsSlice, (contacts) => contacts[occupantId] || []);

// export const occupantContact = (occupantId: number | string, contactId: number | string) =>
//     createSelector(
//         occupantContacts(occupantId),
//         (occupantContacts) => occupantContacts.find((c: OccupantContact) => `${c.contactId}` === `${contactId}`) || {},
//     );

// Property Contacts
const propertiesSlice = createSelector(contactsState, ({ properties }) => properties);

export const contactsAreLoadedForProperty = (propertyId: number | string) =>
    createSelector(propertiesSlice, (contacts) => contacts.hasOwnProperty(propertyId));

export const propertyContacts = (propertyId: number | string) =>
    createSelector(propertiesSlice, (contacts) => contacts[propertyId] || []);

// User Contacts
const userContactsSlice = createSelector(contactsState, ({ userContacts }) => userContacts);

export const userContacts = createSelector(userContactsSlice, ({ loadStatus, ...rest }) => rest);